import moment from 'moment';

export class WorkdayModel {
    public currentTimesheetDuration: moment.Duration;
    public workDate: moment.Moment;
    public submittedTimesheetDuration: moment.Duration;
    public constructor(date: moment.Moment, totalHours?: moment.Duration, previousTimesheetDuration?: moment.Duration) {
        this.submittedTimesheetDuration = moment.duration(previousTimesheetDuration ?? 0);
        this.workDate = date.clone();
        this.currentTimesheetDuration = moment.duration(totalHours ?? 0);
    }
}

export class WorkdayModelFromJson extends WorkdayModel {
    public constructor(data: JsonWorkDayModel) {
        super(
            moment(data.workDate),
            moment.duration(data.currentTimesheetDuration),
            moment.duration(data.submittedTimesheetDuration),
        );
    }
}

export interface JsonWorkDayModel {
    currentTimesheetDuration: string;
    workDate: string;
    submittedTimesheetDuration: string;
}
